import { render } from "./ToDoList.vue?vue&type=template&id=35869cc3&scoped=true"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"

import "./ToDoList.vue?vue&type=style&index=0&id=35869cc3&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1768814729495645082/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35869cc3"]])

export default __exports__